import { render, staticRenderFns } from "./EditMoney.vue?vue&type=template&id=f83cefec&"
import script from "./EditMoney.vue?vue&type=script&lang=js&"
export * from "./EditMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports